import Vue from 'vue'
import Router from 'vue-router'
import main from '@/components/main'
import topnav from '@/components/topnav'
import helloworld from '@/components/HelloWorld'

const com = name => () => import('@/components/' + name)
const view = name => () => import('@/views/' + name)

Vue.use(Router)

export default new Router({
  routes: [
    // {
    //   path: '/DataV',
    //   name: 'DataV',
    //   component: view('DataV'),
    // },
    {
      path: '/biBoard',
      name: 'biBoard',
      component: view('presentation/biBoard'),
    },
    {
      path: '/storePresentation',
      name: 'storePresentation',
      meta: {
        type: 'store' // 增加type字段，区分在唐吉e购模块调用接口更换api代理为em 开头 例如 emapidev
      },
      component: view('storePresentation/storePresentation'),
    },
    {
      path: '/hello',
      name: 'hello',
      component: helloworld,
    },
    {
      path: '/',
      name: 'default',
      meta: {
        title: '登录',
      },
      redirect: {
        name: 'login',
      },
    },
    {
      path: '/login',
      name: 'login',
      component: view('login.vue'),
      meta: {
        title: '登录',
      },
    },
    {
      path: '/pdfpreview',
      name: 'pdfpreview',
      component: view('pdfpreview'),
    },
    {
      path: '/unjoinedBuilderList',
      name: 'unjoinedBuilderList',
      component: view('account/unjoinedCompanyList.vue'),
      meta: {
        title: '未加盟企业管理-施工单位',
        role: 'builder',
      },
    },
    {
      path: '/unjoinedSupplierList',
      name: 'unjoinedSupplierList',
      component: view('account/unjoinedCompanyList.vue'),
      meta: {
        title: '未加盟企业管理-建材供应商',
        role: 'supplier',
      },
    },
    //企业账户管理
    {
      path: '/Administration',
      name: 'Administration',
      component: view('account/Administration.vue'),
      meta: {
        title: '甲方',
        routeTitle: '甲方'
      },
    },
    // {
    //   path: '/NewsList',
    //   name: 'NewsList',
    //   component: view('news/NewsList.vue'),
    //   meta: {
    //     title: '门户信息',
    //   },
    // },
    {
      path: '/report',
      name: 'report',
      component: view('report/list'),
      meta: {
        title: '举报中心',
        routeTitle: '举报中心'
      },
    },
    // {
    //   path: '/TjChart',
    //   name: 'TjChart',
    //   component: view('news/TjChart.vue'),
    //   meta: {
    //     title: '唐吉指数',
    //   },
    // },
    {
      path: '/buildCompany',
      name: 'buildCompany',
      component: view('account/company.vue'),
      meta: {
        title: '供应商',
        routeTitle: '供应商',
        mall_group: 2,
      },
    },
    {
      path: '/materialSupplier',
      name: 'materialSupplier',
      component: view('account/materialSupplier.vue'),
      meta: {
        title: '材料商',
        routeTitle: '材料商',
        mall_group: 1,
      },
    },
    {
      path: '/punishList',
      name: 'punishList',
      component: view('account/punish/PunishList.vue'),
      meta: {
        title: '处罚管理',
        routeTitle: '处罚管理'
      },
    },
    {
      path: '/worker',
      name: 'worker',
      component: view('account/worker/worker.vue'),
      meta: {
        title: '工人',
        routeTitle: '工人',
        mall_group: 2,
      },
    },
    {
      path: '/visitCompany',
      name: 'visitCompany',
      component: view('account/visit/visitCompany.vue'),
      meta: {
        title: '回访跟踪',
        routeTitle: '回访跟踪',
        mall_group: 2,
      },
    },
    {
      path: '/auditCompany',
      name: 'auditCompany',
      component: view('account/audit/auditCompany.vue'),
      meta: {
        title: '企业审核',
        routeTitle: '企业审核',
        mall_group: 2,
      },
    },
    {
      path: '/companyUser',
      name: 'companyUser',
      component: view('account/userList.vue'),
      meta: {
        title: '企业用户',
        routeTitle: '企业用户',
        mall_group: 2,
      },
    },
    {
      path: '/personUser',
      name: 'personUser',
      component: view('account/userList.vue'),
      meta: {
        title: '个人用户',
        routeTitle: '个人用户',
        mall_group: 2,
      },
    },
    {
      path: '/collectDeposit',
      name: 'collectDeposit',
      component: view('account/collectDeposit/collectDeposit.vue'),
      meta: {
        title: '收保证金',
        routeTitle: '保证金',
        mall_group: 2,
      },
    },
    {
      path: '/refundOfDeposit',
      name: 'refundOfDeposit',
      component: view('account/refundOfDeposit/refundOfDeposit.vue'),
      meta: {
        title: '退保证金',
        routeTitle: '退保证金',
        mall_group: 2,
      },
    },
    {
      path: '/deductDeposit',
      name: 'deductDeposit',
      component: view('account/deductDeposit/deductDeposit.vue'),
      meta: {
        title: '扣保证金',
        routeTitle: '扣保证金',
        mall_group: 2,
      },
    },
    {
      path: '/ledger',
      name: 'ledger',
      component: view('account/ledger/ledger.vue'),
      meta: {
        title: '保证金台账',
        routeTitle: '保证金台账',
        mall_group: 2,
      },
    },
    {
      path: '/saasEnterprise',
      name: 'saasEnterprise',
      component: view('account/saasEnterprise/saasEnterprise.vue'),
      meta: {
        title: '企业管理',
        routeTitle: '企业管理',
        mall_group: 2,
      },
    },
    // 门户管理 
    {
      path: '/NewsList',
      name: 'NewsList',
      component: view('news/NewsList.vue'),
      meta: {
        title: '门户新闻',
        routeTitle: '门户新闻'
      },
    },
    {
      path: '/ContentList',
      name: 'ContentList',
      component: view('cms/Content/ContentList.vue'),
      meta: {
        title: '内容管理',
        routeTitle: '内容管理'
      },
    },
    {
      path: '/QuestionList',
      name: 'QuestionList',
      component: view('cms/Question/QuestionList.vue'),
      meta: {
        title: '题库管理',
        routeTitle: '题库管理'
      },
    },
    {
      path: '/ExamList',
      name: 'ExamList',
      component: view('cms/Exam/ExamList.vue'),
      meta: {
        title: '供应商考核',
        routeTitle: '考核'
      },
    },
    {
      path: '/PointList',
      name: 'PointList',
      component: view('cms/Point/PointList.vue'),
      meta: {
        title: '积分台账',
        routeTitle: '积分'
      },
    },
    {
      path: '/TaskList',
      name: 'TaskList',
      component: view('cms/Task/TaskList.vue'),
      meta: {
        title: '积分任务',
        routeTitle: '积分任务'
      },
    },
    // Saas中心
    {
      path: '/saasCustomerList',
      name: 'saasCustomerList',
      component: view('SaasManagement/customerList/customerList.vue'),
      meta: {
        title: '客户列表',
        routeTitle: '客户管理-客户列表'
      },
    },
    {
      path: '/saasCustomerRecords',
      name: 'saasCustomerRecords',
      component: view('SaasManagement/customerRecords/customerRecords.vue'),
      meta: {
        title: '跟踪记录',
        routeTitle: '客户管理-跟踪记录'
      },
    },
    {
      path: '/saasCustomerSetting',
      name: 'saasCustomerSetting',
      component: view('SaasManagement/customerSetting/customerSetting.vue'),
      meta: {
        title: '字典配置',
        routeTitle: '客户管理-字典配置'
      },
    },
    {
      path: '/TjChart',
      name: 'TjChart',
      component: view('news/TjChart.vue'),
      meta: {
        title: '唐吉指数',
      },
    },
    // 企业后台管理
    {
      name: 'company',
      path: '/company/:eid',
      component: view('company/content'),
      children: [
        {
          path: 'info',
          name: 'info',
          component: view('company/info'),
          meta: {
            title: '企业后台管理-企业信息管理',
          },
        },
        {
          path: 'shop',
          name: '/shop',
          component: view('company/shop'),
          meta: {
            title: '企业后台管理-店铺展示管理',
          },
        },
        {
          path: 'project',
          name: 'project',
          component: view('company/project'),
          meta: {
            title: '企业后台管理-项目展示管理',
          },
        },
        {
          path: 'projectForm/:id',
          name: 'projectForm',
          component: view('company/projectForm'),
          meta: {
            title: '企业后台管理-项目展示管理',
          },
        },
        {
          path: 'projectInfo/:id',
          name: 'projectInfo',
          component: view('company/projectInfo'),
          meta: {
            title: '企业后台管理-项目展示管理',
          },
        },
        {
          path: 'good',
          name: 'good',
          component: view('company/good'),
          meta: {
            title: '企业后台管理-商品展示管理',
          },
        },
        {
          path: 'goodForm/:id',
          name: 'goodForm',
          component: view('company/goodForm'),
          meta: {
            title: '企业后台管理-商品展示管理',
          },
        },
        {
          path: 'goodInfo/:id',
          name: 'goodInfo',
          component: view('company/goodInfo'),
          meta: {
            title: '企业后台管理-商品展示管理',
          },
        },
        {
          path: 'method',
          name: 'method',
          component: view('company/method'),
          meta: {
            title: '企业后台管理-工艺展示管理',
          },
        },
        {
          path: 'methodForm/:id',
          name: 'methodForm',
          component: view('company/methodForm'),
          meta: {
            title: '企业后台管理-工艺展示管理',
          },
        },
        {
          path: 'methodInfo/:id',
          name: 'methodInfo',
          component: view('company/methodInfo'),
          meta: {
            title: '企业后台管理-工艺展示管理',
          },
        },
        {
          path: 'member',
          name: 'member',
          component: view('company/member'),
          meta: {
            title: '企业后台管理-企业团队管理',
          },
        },
        {
          path: 'certificate',
          name: 'certificate',
          component: view('company/certificate'),
          meta: {
            title: '企业后台管理-企业资质管理',
          },
        },
      ],
    },
    {
      path: '/Statistics',
      name: 'Statistics',
      component: view('account/Statistics.vue'),
      meta: {
        title: '数据分析管理',
      },
    },
    // 升级管理
    {
      path: '/App',
      name: 'App',
      component: view('app/appindex.vue'),
      meta: {
        title: 'APP升级管理',
        routeTitle: 'App升级管理'
      },
    },
    {
      path: '/Zero',
      name: 'Zero',
      component: view('app/zeroindex.vue'),
      meta: {
        title: 'Zero升级管理',
        routeTitle: 'Zero升级管理'
      },
    },
    {
      path: '/Saas',
      name: 'Saas',
      component: view('app/saasindex.vue'),
      meta: {
        title: 'SaaS升级管理',
        routeTitle: 'SAAS升级管理'
      },
    },
    {
      path: '/tv',
      name: 'tv',
      component: view('presentation/tv'),
      meta: {
        title: '数据大屏',
        routeTitle: '数据大屏'
      },
    },
    {
      path: '/eFitUp',
      name: 'eFitUp',
      component: view('bi/eFitUp'),
      meta: {
        title: 'e装数据',
        routeTitle: 'e装数据'
      },
    },
    {
      path: '/biproject/:global_id',
      name: 'biproject',
      component: view('bi/project'),
      meta: {
        title: 'e装项目数据',
        routeTitle: 'e装项目数据'
      },
    },
    {
      path: '/eBuy',
      name: 'eBuy',
      component: view('bi/eBuy'),
      meta: {
        title: 'e购数据',
        routeTitle: 'e购数据'
      },
    },
    {
      path: '/presentation',
      name: 'presentation',
      component: view('presentation/presentation'),
      meta: {
        title: '数据大屏',
        routeTitle: '数据大屏'
      },
    },
    {
      path: '/dataStatistics',
      name: 'dataStatistics',
      component: view('account/dataStatistics.vue'),
      meta: {
        title: '项目信息',
      },
    },
    {
      path: '/shang',
      name: 'shang',
      component: view('account/shang.vue'),
    },
    // 企业库维护
    {
      path: '/progressTemplate',
      name: 'progressTemplate',
      component: view('speed/progressTemplate.vue'),
      meta: {
        title: '进度模板',
        routeTitle: '进度'
      },
    },
    {
      path: '/scheduleConfig',
      name: 'scheduleConfig',
      component: view('speed/scheduleConfig/scheduleConfig.vue'),
      meta: {
        title: '自动生成进度配置',
      },
    },
    {
      path: '/progressTemplateDetail/:tid',
      name: 'progressTemplateDetail',
      component: view('speed/progressTemplate/construct/proconstructplan'),
      meta: {
        title: '查看模板',
      },
    },
    {
      path: '/surveyEdition',
      name: 'surveyEdition',
      component: view('survey/surveyEdition/surveyEdition.vue'),
      meta: {
        title: '踏勘版本管理',
        routeTitle: '踏勘'
      },
    },
    {
      path: '/surveyRecommend',
      name: 'surveyRecommend',
      component: view('survey/surveyRecommend/surveyRecommend.vue'),
      meta: {
        title: '踏勘推荐',
      },
    },
    // 商品相关路由
    {
      path: '/classification',
      name: 'classification',
      component: view('goods/classification/classification.vue'),
      meta: {
        title: '商品分类管理',
      },
    },
    {
      path: '/Information',
      name: 'Information',
      component: view('goods/Information/Information.vue'),
      meta: {
        title: '商品信息维护',
      },
    },
    {
      path: '/toBeReviewed',
      name: 'toBeReviewed',
      component: view('goods/toBeReviewed/toBeReviewed.vue'),
      meta: {
        title: '待审核商品',
      },
    },
    // 关键词回复
    {
      path: '/onlineCustomerService',
      name: 'onlineCustomerService',
      component: view('customerServiceCenter/onlineCustomerService/onlineCustomerService.vue'),
      meta: {
        title: '在线客服',
        routeTitle: '客服管理',
        type: 'store'
      },
    },
    // 客服管理
    {
      path: '/customerServicePersonnelManagement',
      name: 'customerServicePersonnelManagement',
      component: view('customerServiceCenter/customerServicePersonnelManagement/index.vue'),
      meta: {
        title: '客服人员管理',
        routeTitle: '客服人员管理',
        type: 'store'
      },
    },
    // 关键词回复
    {
      path: '/keywordConfig',
      name: 'keywordConfig',
      component: view('customerServiceCenter/keywordConfig/keywordConfig.vue'),
      meta: {
        title: '关键词回复',
        type: 'storeOrbim'
      },
    },
    // 用户开票管理
    {
      path: '/userInvoiceManage',
      name: 'userInvoiceManage',
      component: view('tjStore/InvoiceCenter/userInvoiceManage/table.vue'),
      meta: {
        title: '用户开票管理',
        type: 'store'
      },
    },
    // 商户开票管理
    {
      path: '/platformInvoicingManage',
      name: 'platformInvoicingManage',
      component: view('tjStore/InvoiceCenter/platformInvoicingManage/table.vue'),
      meta: {
        title: '商户开票管理',
        type: 'store'
      },
    },
    // 店铺等级配置
    {
      path: '/shopLevelConfig',
      name: 'shopLevelConfig',
      component: view('tjStore/MerchantManagement/ShopLevelConfig/table.vue'),
      meta: {
        title: '店铺等级配置',
        type: 'store'
      },
    },
    // 商家收入明细
    {
      path: '/incomeDetailsManage',
      name: 'incomeDetailsManage',
      component: view('tjStore/IncomeAndExpensesCenter/IncomeDetailsManage/table.vue'),
      meta: {
        title: '商家收入明细',
        type: 'store'
      },
    },
    // 商家佣金费用支出
    {
      path: '/commissionExpenseManage',
      name: 'commissionExpenseManage',
      component: view('tjStore/IncomeAndExpensesCenter/CommissionExpenseManage/table.vue'),
      meta: {
        title: '商家佣金费用支出',
        type: 'store'
      },
    },
    // e购中心
    {
      path: '/eLoginUserManage',
      name: 'eLoginUserManage',
      component: view('tjStore/UserManagement/LoginUserManage/index.vue'),
      meta: {
        title: '登录用户管理',
        routeTitle: '登录用户管理',
        type: 'store'
      },
    },
    {
      path: '/eFileInfoOptionManage',
      name: 'eFileInfoOptionManage',
      component: view('tjStore/UserManagement/FileInfoOptionManage/index.vue'),
      meta: {
        title: '档案信息选项管理',
        routeTitle: '档案信息选项管理',
        type: 'store'
      },
    },
    {
      path: '/eMerchantManagement',
      name: 'eMerchantManagement',
      component: view('tjStore/MerchantManagement/MerchantManagement.vue'),
      meta: {
        title: '商家信息管理',
        routeTitle: '商家信息管理',
        type: 'store'
      },
    },
    {
      path: '/eInvestmentClueManagement',
      name: 'eInvestmentClueManagement',
      component: view('tjStore/MerchantManagement/InvestmentClueManagement/InvestmentClueManagement.vue'),
      meta: {
        title: '招商线索管理',
        type: 'store'
      },
    },
    {
      path: '/eMerchantReview',
      name: 'eMerchantReview',
      component: view('tjStore/MerchantManagement/MerchantReview.vue'),
      meta: {
        title: '商家信息审核',
        routeTitle: '商家信息审核',
        type: 'store'
      },
    },
    {
      path: '/eMerchantReviewEdit',
      name: 'eMerchantReviewEdit',
      component: view('tjStore/MerchantManagement/MerchantReviewEdit.vue'),
      meta: {
        title: '商家信息审核（修改）',
        type: 'store'
      },
    },
    {
      path: '/eMerchantManagementt',
      name: 'eMerchantManagementt',
      component: view('tjStore/MerchantManagement/MerchantManagementt.vue'),
      meta: {
        title: '全部商家信息（历史）',
      },
    },
    {
      path: '/eShopManagement',
      name: 'eShopManagement',
      component: view('tjStore/ShopManagement/ShopManagement.vue'),
      meta: {
        title: '店铺信息管理',
        routeTitle: '店铺信息管理',
      },
    },
    {
      path: '/eToBeReviewedShopInfo',
      name: 'eToBeReviewedShopInfo',
      component: view('tjStore/ShopManagement/ToBeReviewedShopInfo.vue'),
      meta: {
        title: '店铺信息审核',
        routeTitle: '店铺信息审核',
      },
    },
    {
      path: '/eShopLogOffAudit',
      name: 'eShopLogOffAudit',
      component: view('tjStore/ShopManagement/ShopLogOffAudit/index.vue'),
      meta: {
        title: '店铺注销审核',
        routeTitle: '店铺注销审核',
      },
    },
    {
      path: '/eCommoditySPU',
      name: 'eCommoditySPU',
      component: view('tjStore/Commodity/CommoditySPU/CommoditySPU.vue'),
      meta: {
        title: '商品分类管理',
        routeTitle: '商品管理',
        type: 'store' // 增加type字段，区分在唐吉e购模块调用接口更换api代理为em 开头 例如 emapidev
      },
    },
    {
      path: '/eAllCommodity',
      name: 'eAllCommodity',
      component: view('tjStore/Commodity/AllCommodity/index.vue'),
      meta: {
        title: '全部商品管理',
        type: 'store'
      },
    },
    {
      path: '/eAllSkuManage',
      name: 'eAllSkuManage',
      component: view('tjStore/Commodity/AllSkuManage/table.vue'),
      meta: {
        title: '全部sku管理',
        type: 'store'
      },
    },
    {
      path: '/eToBeReviewedCommodity',
      name: 'eToBeReviewedCommodity',
      component: view('tjStore/Commodity/ToBeReviewedCommodity/ToBeReviewedCommodity.vue'),
      meta: {
        title: '待审核商品管理',
        type: 'store'
      },
    },
    {
      path: '/eToBeReviewedCompany',
      name: 'eToBeReviewedCompany',
      component: view('tjStore/Commodity/ToBeReviewedCompany/ToBeReviewedCompany.vue'),
      meta: {
        title: '待审核商品信息',
        type: 'store'
      },
    },
    {
      path: '/eToBeReviewedCommoditySku',
      name: 'eToBeReviewedCommoditySku',
      component: view('tjStore/Commodity/ToBeReviewedCommoditySku/ToBeReviewedCommoditySku.vue'),
      meta: {
        title: '待审核sku',
        type: 'store'
      },
    },
    {
      path: '/eQuotationSkuSearch',
      name: 'eQuotationSkuSearch',
      component: view('tjStore/Commodity/QuotationSkuSearch/table.vue'),
      meta: {
        title: '报价sku查询',
        type: 'store'
      },
    },
    {
      path: '/eAllOrder',
      name: 'eAllOrder',
      component: view('tjStore/Order/AllOrder/AllOrder.vue'),
      meta: {
        title: '标品订单管理',
        routeTitle: '订单管理',
        type: 'store'
      },
    },
    {
      path: '/eAllCustomizedOrder',
      name: 'eAllCustomizedOrder',
      component: view('tjStore/Order/CustomizedOrder/CustomizedOrder.vue'),
      meta: {
        title: '订制订单管理',
        routeTitle: '订单管理',
        type: 'store'
      },
    },
    {
      path: '/eAllHistoryGeneralOrder',
      name: 'eAllHistoryGeneralOrder',
      component: view('tjStore/Order/historyGeneralOrder.vue'),
      meta: {
        title: '订单管理（历史数据）',
        routeTitle: '订单管理',
        type: 'store'
      },
    },
    {
      path: '/eAfterSalesManage',
      name: 'eAfterSalesManage',
      component: view('tjStore/AfterSalesCenter/afterSalesManage/index.vue'),
      meta: {
        title: '售后管理',
        routeTitle: '售后管理',
        type: 'store'
      },
    },
    {
      path: '/eMaintenanceManage',
      name: 'eMaintenanceManage',
      component: view('tjStore/AfterSalesCenter/maintenanceManage/index.vue'),
      meta: {
        title: '维修管理',
        routeTitle: '维修管理',
        type: 'store'
      },
    },
    {
      path: '/eEvaluationManage',
      name: 'eEvaluationManage',
      component: view('tjStore/AfterSalesCenter/evaluationManage/index.vue'),
      meta: {
        title: '评价管理',
        routeTitle: '评价管理',
        type: 'store'
      },
    },
    {
      path: '/eAllAfterSales',
      name: 'eAllAfterSales',
      component: view('tjStore/Order/AllAfterSales/AllAfterSales.vue'),
      meta: {
        title: '全部售后管理',
        type: 'store'
      },
    },
    {
      path: '/eAfterSalesDetails/:Id',
      name: 'eAfterSalesDetails',
      component: view('tjStore/Order/AllAfterSales/components/details.vue'),
      meta: {
        title: '售后详情',
        type: 'store'
      },
    },
    {
      path: '/eGoodsAfterSalesDetails/:Id',
      name: 'eGoodsAfterSalesDetails',
      component: view('tjStore/Order/AllAfterSales/components/rGoodsDetails.vue'),
      meta: {
        title: '售后详情',
        type: 'store'
      },
    },
    {
      path: '/eOrderSettings',
      name: 'eOrderSettings',
      component: view('tjStore/Order/OrderSettings/OrderSettings.vue'),
      meta: {
        title: '订单配置',
        type: 'store'
      },
    },
    {
      path: '/eByStages',
      name: 'eByStages',
      component: view('tjStore/Marketing/ByStages/CustomizedByStages.vue'),
      meta: {
        title: '订制品分期管理',
        type: 'store'
      },
    },
    {
      path: '/eCustomizedProductProcessConfig',
      name: 'eCustomizedProductProcessConfig',
      component: view('tjStore/Marketing/CustomizedProductProcessConfig/CustomizedProductProcessConfig.vue'),
      meta: {
        title: '订制流程管理',
        type: 'store'
      },
    },
    {
      path: '/eBrandCustomizedProductProcessConfig',
      name: 'eBrandCustomizedProductProcessConfig',
      component: view('tjStore/Marketing/BrandCustomizedProductProcessConfig/BrandCustomizedProductProcessConfig.vue'),
      meta: {
        title: '品牌方订制流程',
        type: 'store'
      },
    },
    {
      path: '/eWebsiteConfig',
      name: 'eWebsiteConfig',
      component: view('tjStore/Marketing/WebsiteConfig/WebsiteConfig.vue'),
      meta: {
        title: '名企之选',
        routeTitle: '营销管理',
        type: 'store'
      },
    },
    {
      path: '/eCustomizedroductTemplateManage',
      name: 'eCustomizedroductTemplateManage',
      component: view('tjStore/Marketing/CustomizedroductTemplateManage/index.vue'),
      meta: {
        title: '订制商品模板管理',
        routeTitle: '订制商品模板管理',
        type: 'store'
      },
    },
    {
      path: '/eCalculatorSettings',
      name: 'eCalculatorSettings',
      component: view('tjStore/Marketing/CalculatorSettings/CalculatorSettings.vue'),
      meta: {
        title: '计算器配置',
        type: 'store'
      },
    },
    {
      path: '/eStandardCalculatorConfigs',
      name: 'eStandardCalculatorConfigs',
      component: view('tjStore/Marketing/StandardCalculatorConfigs/index.vue'),
      meta: {
        title: '标品计算器',
        type: 'store'
      },
    },
    {
      path: '/eCustomizedCalculatorConfigs',
      name: 'eCustomizedCalculatorConfigs',
      component: view('tjStore/Marketing/CustomizedCalculatorConfigs/index.vue'),
      meta: {
        title: '订制品计算器',
        type: 'store'
      },
    },
    {
      path: '/eSettlementDocManagement',
      name: 'eSettlementDocManagement',
      component: view('tjStore/Settlement/SettlementDocManagement/SettlementDocManagement.vue'),
      meta: {
        title: '结算单管理',
        routeTitle: '结算管理',
        type: 'store'
      },
    },
    {
      path: '/eSettlementBill',
      name: 'eSettlementBill',
      component: view('tjStore/Settlement/SettlementBill/index.vue'),
      meta: {
        title: '账单管理',
        routeTitle: '账单管理',
        type: 'store'
      },
    },
    {
      path: '/eAlipayBillManage',
      name: 'eAlipayBillManage',
      component: view('tjStore/Settlement/AlipayBillManage/index.vue'),
      meta: {
        title: '支付宝账单管理',
        routeTitle: '支付宝账单管理',
        type: 'store'
      },
    },
    {
      path: '/eAllSettlement',
      name: 'eAllSettlement',
      component: view('tjStore/Settlement/AllSettlement/AllSettlement.vue'),
      meta: {
        title: '全部结算单',
        routeTitle: '结算管理',
        type: 'store'
      },
    },
    {
      path: '/eToBeSettlemtnt',
      name: 'eToBeSettlemtnt',
      component: view('tjStore/Settlement/ToBeSettlemtnt/ToBeSettlemtnt.vue'),
      meta: {
        title: '待结款结算单',
        type: 'store'
      },
    },
    {
      path: '/eToBeReviewedSettlement',
      name: 'eToBeReviewedSettlement',
      component: view('tjStore/Settlement/ToBeReviewedSettlement/ToBeReviewedSettlement.vue'),
      meta: {
        title: '待审核结算单',
        type: 'store'
      },
    },
    {
      path: '/eSettlementDetails/:Id',
      name: 'eSettlementDetails',
      component: view('tjStore/Settlement/components/details.vue'),
      meta: {
        title: '结算详情',
        type: 'store'
      },
    },
    {
      path: '/eCommodityDetails/:SkuId',
      name: 'eCommodityDetails',
      component: view('tjStore/Commodity/components/details.vue'),
      meta: {
        title: '商品审核',
        type: 'store'
      },
    },
    {
      path: '/eCommodityDetailsSku/:SkuId',
      name: 'eCommodityDetailsSku',
      component: view('tjStore/Commodity/components/detailsSku.vue'),
      meta: {
        title: 'Sku审核',
        type: 'store'
      },
    },
    {
      path: '/eCompanyDetails/:SkuId',
      name: 'eCompanyDetails',
      component: view('tjStore/Commodity/components/Companydetails.vue'),
      meta: {
        title: '商品信息审核',
        type: 'store'
      },
    },
    {
      path: '/eContractEntry',
      name: 'eContractEntry',
      component: view('tjStore/Contract/ContractEntry/ContractEntry.vue'),
      meta: {
        title: '合同录入',
        routeTitle: '合同管理',
        type: 'store'
      },
    },
    {
      path: '/eContractAccount',
      name: 'eContractAccount',
      component: view('tjStore/Contract/ContractAccount/ContractAccount.vue'),
      meta: {
        title: '合同台账',
        type: 'store'
      },
    },
    {
      path: '/eAppBasicSettings',
      name: 'eAppBasicSettings',
      component: view('tjStore/BasicSettings/AppBasicSettings/AppBasicSettings.vue'),
      meta: {
        title: 'e购运营位管理',
        routeTitle: '基础设置',
        type: 'store'
      },
    },
    {
      path: '/eKnowledgeColumnManage',
      name: 'eKnowledgeColumnManage',
      component: view('tjStore/Marketing/KnowledgeColumnManage/index.vue'),
      meta: {
        title: '知识专栏管理',
        routeTitle: '知识专栏管理',
        type: 'store'
      },
    },
    {
      path: '/eSpuSearchKeywordManage',
      name: 'eSpuSearchKeywordManage',
      component: view('tjStore/Marketing/SpuSearchKeywordManage/table.vue'),
      meta: {
        title: 'SPU搜索关键词管理',
        routeTitle: 'SPU搜索关键词管理',
        type: 'store'
      },
    },
    {
      path: '/eSpuAssociationManage',
      name: 'eSpuAssociationManage',
      component: view('tjStore/Marketing/SpuAssociationManage/table.vue'),
      meta: {
        title: 'SPU关联管理',
        routeTitle: 'SPU关联管理',
        type: 'store'
      },
    },
    {
      path: '/eOrderTimeControlConfig',
      name: 'eOrderTimeControlConfig',
      component: view('tjStore/BasicSettings/OrderTimeControlConfig/index.vue'),
      meta: {
        title: '订单时间管控配置（全局）',
        type: 'store'
      },
    },
    {
      path: '/eSettlementConfigurationGlobal',
      name: 'eSettlementConfigurationGlobal',
      component: view('tjStore/BasicSettings/SettlementConfigurationGlobal/index.vue'),
      meta: {
        title: '结算配置（全局）',
        type: 'store'
      },
    },
    {
      path: '/eAppWhitelistManagement',
      name: 'eAppWhitelistManagement',
      component: view('tjStore/BasicSettings/AppWhitelistManagement/AppWhitelistManagement.vue'),
      meta: {
        title: '白名单(集采)',
        type: 'store'
      },
    },
    // 材料定额库
    {
      path: '/StandardQuotaManagement',
      name: 'StandardQuotaManagement',
      component: view('MaterialQuotaLibrary/StandardQuota/StandardQuotaManagement/index.vue'),
      meta: {
        title: '标准品定额管理',
        routeTitle: '标准品定额',
      },
    },
    {
      path: '/StandardQuotaAudit',
      name: 'StandardQuotaAudit',
      component: view('MaterialQuotaLibrary/StandardQuota/StandardQuotaAudit/index.vue'),
      meta: {
        title: '标准品定额审核',
        routeTitle: '标准品定额审核',
      },
    },
    {
      path: '/CustomQuotaManagement',
      name: 'CustomQuotaManagement',
      component: view('MaterialQuotaLibrary/CustomQuota/CustomQuotaManagement/index.vue'),
      meta: {
        title: '订制品定额管理',
        routeTitle: '订制品定额',
      },
    },
    {
      path: '/CustomQuotaAudit',
      name: 'CustomQuotaAudit',
      component: view('MaterialQuotaLibrary/CustomQuota/CustomQuotaAudit/index.vue'),
      meta: {
        title: '订制品定额审核',
        routeTitle: '订制品定额审核',
      },
    },
    {
      path: '/QuotaLibraryVersionManage',
      name: 'QuotaLibraryVersionManage',
      component: view('MaterialQuotaLibrary/QuotaLibraryVersionManage/QuotaLibraryVersionManage/index.vue'),
      meta: {
        title: '定额库版本管理',
        routeTitle: '定额库版本管理',
      },
    },
    // BOS中心
    {
      path: '/CustomerManagementList',
      name: 'CustomerManagementList',
      component: view('BosCenter/CustomerManagement/CustomerManagementList/index.vue'),
      meta: {
        title: '客户管理',
        routeTitle: '客户管理',
        type: 'storeOrbim'
      },
    },
    {
      path: '/DictionaryConfiguration',
      name: 'DictionaryConfiguration',
      component: view('BosCenter/CustomerManagement/DictionaryConfiguration/index.vue'),
      meta: {
        title: '字典配置',
        routeTitle: '字典配置'
      },
    },
    {
      path: '/CustomerManagementDetails/:Id',
      name: 'CustomerManagementDetails',
      component: view('BosCenter/CustomerManagement/CustomerManagementList/details/details.vue'),
      meta: {
        title: '客户详情',
        type: 'storeOrbim'
      },
    },
    {
      path: '/tenderProject',
      name: 'tenderProject',
      component: view('BosCenter/SampleDatabase/tenderProject/tenderProject.vue'),
      meta: {
        title: '招标项目管理',
        routeTitle: '样品资料库',
        type: 'storeOrbim'
      },
    },
    {
      path: '/winningInstructions',
      meta: { title: '中标通知书' },
      component: view('BosCenter/SampleDatabase/tenderProject/winningInstructions.vue'),
    },
    {
      path: '/sampleLibrary',
      name: 'sampleLibrary',
      component: view('BosCenter/SampleDatabase/SampleLibrary/index.vue'),
      meta: {
        title: '样品库',
        routeTitle: '样品库',
        type: 'storeOrbim'
      },
    },
    // 权限人员管理
    {
      path: '/RightsManagement',
      name: 'RightsManagement',
      component: view('PermissionPersonnelManagement/RightsManagement/index.vue'),
      meta: {
        title: '权限管理',
        routeTitle: '权限管理'
      },
    },
    {
      path: '/UsersManagement',
      name: 'UsersManagement',
      component: view('PermissionPersonnelManagement/UsersManagement/index.vue'),
      meta: {
        title: '后台人员管理',
        routeTitle: '后台人员管理'
      },
    },
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js